export default {
  catalog: {
    menu: {
      catalog: 'Catálogo',
    },
    breadcrumbs: {
      catalog: 'Catálogo',
      search: 'Búsqueda',
    },
    entity: {
      name: 'Nombre del material',
      description: 'Descripción del material',
      sku: 'SKU',
      code: 'Código',
      manufacturer: 'Fabricante',
      manufacturer_partnumber: 'Número de parte',
      uom: 'Unidad de medida',
      price: 'Precio',
      class: 'Clase',
      colloquial: 'Coloquial',
      keywords: 'Palabras clave',
      currency: 'Moneda',
      category: 'Clase',
      noun: 'Nombre del Elemento',
      modifier: 'Modificador',
      has_stock: 'Stock disponible',
      is_obsolete: 'Se encuentra obsoleto',
      is_active: 'Se encuentra activo',
      technical_specification: 'Descripción',
    },
    pages: {
      '_admin-manage-products': {
        title: 'Administrador de productos',
        actions: {
          create: {
            title: 'Crear Producto',
            help: 'Opción para crear un producto nuevo en el catálogo',
          },
        },
      },
      '_admin-manage-product': {
        title: 'Administrar producto',
        actions: {
          save_changes: 'Guardar Cambios',
        },
      },
      search: {
        title: 'Búsqueda de productos',
        placeholders: {
          searchBy: 'Buscar por palabras clave...',
        },
        actions: {
          search: 'Buscar',
          edit: 'Editar',
        },
      },
      product: {
        title: 'Producto',
        tabs: {
          attributes: 'Atributos',
          manufacturer: 'Fabricante',
          classification: 'Clasificación',
          attachment: 'Adjuntos',
          general: 'Información General',
          stock: 'Stock',
          technical_specification: 'Información adicional',
        },
        tables: {
          attributes: {
            headers: {
              position: 'Posición',
              attribute: 'Atributo',
              value: 'Valor',
            },
          },
          attachment: {
            headers: {
              filename: 'Nombre del archivo',
              action: 'Acción',
            },
          },
          stock: {
            headers: {
              quantity: 'Cantidad',
              uom: 'UOM',
              country: 'País',
              city: 'Ciudad',
            },
          },
          technical_specification: {
            headers: {
              title: 'Especificación',
            },
          },
        },
        actions: {
          catalog: 'Catalog',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/catalog.js